module.exports = __webpack_public_path__ + "static/img/head_neck.c7b5f93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/organs/head_neck.png
// module id = kO4g
// module chunks = 1